import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-image-preview',
    template: `<img [src]="imageToShow">`,
    styles: ['img{max-width:100%}'],
    encapsulation: ViewEncapsulation.None
})

export class ImagePreviewComponent implements OnInit {

  @Input() imageUrl: string;

  imageToShow: any;
  
  constructor(
    private http: HttpClient,
  ) { }

  ngOnInit() {

    this.getImageFromService();

  }

  getImage(imageUrl: string): Observable<Blob> {
    return this.http.get(imageUrl, { responseType: 'blob' });
  }
  
  getImageFromService() {
    this.getImage(this.imageUrl).subscribe(data => {
      this.createImageFromBlob(data);
    });
  }

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
       this.imageToShow = reader.result;
       console.log(this.imageToShow);
    }, false);

    if (image) {
       reader.readAsDataURL(image);
    }
  }

}